export default {
  styleOverrides: {
    root: {
      textTransform: 'none',
      borderRadius: '8px',
      fontWeight: 500,
      transition: 'all 0.2s ease',

      '&.Mui-disabled': {
        color: 'var(--color-text-disabled)',
        backgroundColor: 'var(--color-action-disabled-bg)',
      },
    },

    contained: {
      boxShadow: 'none',

      '&:hover': {
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      },

      '&:active': {
        boxShadow: 'none',
      },
    },

    containedPrimary: {
      backgroundColor: 'var(--color-primary)',
      color: 'white',

      '&:hover': {
        backgroundColor: 'var(--color-primary-hover)',
      },
    },

    containedSecondary: {
      backgroundColor: 'var(--color-secondary)',
      color: 'var(--color-secondary-contrast)',

      '&:hover': {
        backgroundColor: 'var(--color-secondary-dark)',
      },
    },

    containedError: {
      backgroundColor: 'var(--color-error)',
      color: 'var(--color-error-contrast)',

      '&:hover': {
        backgroundColor: 'var(--color-error-dark)',
      },
    },

    containedWarning: {
      backgroundColor: 'var(--color-warning)',
      color: 'var(--color-warning-contrast)',

      '&:hover': {
        backgroundColor: 'var(--color-warning-dark)',
      },
    },

    containedSuccess: {
      backgroundColor: 'var(--color-success)',
      color: 'var(--color-success-contrast)',

      '&:hover': {
        backgroundColor: 'var(--color-success-dark)',
      },
    },

    outlined: {
      borderColor: 'var(--color-border)',
      color: 'var(--color-text-primary)',

      '&:hover': {
        borderColor: 'var(--color-primary)',
        backgroundColor: 'var(--color-action-hover)',
      },
    },

    outlinedPrimary: {
      borderColor: 'var(--color-primary)',
      color: 'var(--color-primary)',

      '&:hover': {
        borderColor: 'var(--color-primary-dark)',
        backgroundColor: 'rgba(37, 99, 235, 0.04)',
      },
    },

    outlinedError: {
      borderColor: 'var(--color-error)',
      color: 'var(--color-error)',

      '&:hover': {
        borderColor: 'var(--color-error-dark)',
        backgroundColor: 'rgba(220, 38, 38, 0.04)',
      },
    },

    outlinedWarning: {
      borderColor: 'var(--color-warning)',
      color: 'var(--color-warning)',

      '&:hover': {
        borderColor: 'var(--color-warning-dark)',
        backgroundColor: 'rgba(245, 158, 11, 0.04)',
      },
    },

    outlinedSuccess: {
      borderColor: 'var(--color-success)',
      color: 'var(--color-success)',

      '&:hover': {
        borderColor: 'var(--color-success-dark)',
        backgroundColor: 'rgba(34, 197, 94, 0.04)',
      },
    },

    text: {
      color: 'var(--color-text-primary)',

      '&:hover': {
        backgroundColor: 'var(--color-action-hover)',
      },
    },

    textPrimary: {
      color: 'var(--color-primary)',

      '&:hover': {
        backgroundColor: 'rgba(37, 99, 235, 0.04)',
      },
    },

    textError: {
      color: 'var(--color-error)',

      '&:hover': {
        backgroundColor: 'rgba(220, 38, 38, 0.04)',
      },
    },

    textWarning: {
      color: 'var(--color-warning)',

      '&:hover': {
        backgroundColor: 'rgba(245, 158, 11, 0.04)',
      },
    },

    textSuccess: {
      color: 'var(--color-success)',

      '&:hover': {
        backgroundColor: 'rgba(34, 197, 94, 0.04)',
      },
    },

    sizeLarge: {
      padding: '12px 24px',
      fontSize: '1rem',
    },

    sizeMedium: {
      padding: '8px 20px',
      fontSize: '0.875rem',
    },

    sizeSmall: {
      padding: '4px 12px',
      fontSize: '0.8125rem',
    },
  },
};
